import {
  customerMarketShopfrontJobsApi,
  marketApi
} from '@envato/foundation-types'
import { ActionCreator } from 'react-redux'
import { ThunkAction } from 'redux-thunk'

import { setSeoMeta } from '../actions/common'
import { reportPageType } from '../analytics'
import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'

import { IRootState } from '../../common/reducers'
import { ISeoMetadata } from '../../typings/seoMetadata'
import { reportProductsImpressions } from '../analytics/resultAnalytics'
import { ICommonLocation } from '../utils/location/types'

export enum TypeKeys {
  GET_HOME_PAGE_API_SUCCESS = 'GET_HOME_PAGE_API_SUCCESS',
  GET_HOME_PAGE_API_FAIL = 'GET_HOME_PAGE_API_FAIL'
}

export interface IHomePageApiData {
  readonly metadata?: ISeoMetadata
  readonly newest_items?: customerMarketShopfrontJobsApi.INewestItemsResult
  readonly featured_items?: customerMarketShopfrontJobsApi.IBaseResult
  readonly free_items?: customerMarketShopfrontJobsApi.IBaseResult
  readonly featured_author?: customerMarketShopfrontJobsApi.IFeaturedAuthorResult
  readonly categories?: marketApi.CategoriesResult
}

export interface IGetHomePageApiSuccessAction {
  type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
  payload: Readonly<IHomePageApiData>
}

export interface IGetHomePageApiFailAction {
  type: TypeKeys.GET_HOME_PAGE_API_FAIL
}

export type ActionTypes =
  | IGetHomePageApiSuccessAction
  | IGetHomePageApiFailAction

export const onBeforeHomePageView = (): ThunkAction<void, IRootState, void> => (
  dispatch,
  getState
) => {
  const { featuredItems, freeItems, featuredAuthor } = getState().homePage
  const currentSite = getState().common.currentSite

  reportPageType('home')

  if (featuredItems) {
    reportProductsImpressions({
      items: featuredItems.matches.slice(0, 10),
      currentSite,
      itemRankOffset: 1,
      page: 'Homepage',
      section: 'Featured items'
    })
  }

  if (freeItems) {
    reportProductsImpressions({
      items: freeItems.matches.slice(0, 6),
      currentSite,
      itemRankOffset: 1,
      page: 'Homepage',
      section: 'Free files of the month'
    })
  }

  if (featuredAuthor) {
    reportProductsImpressions({
      items: featuredAuthor.matches.slice(0, 3),
      currentSite,
      itemRankOffset: 1,
      page: 'Homepage',
      section: 'Featured authors'
    })
  }
}

export const fetchHomePageDataBySite: ActionCreator<
  ThunkAction<Promise<ActionTypes>, IRootState, void>
> = (location: ICommonLocation, apiUrlPrefix: string) => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    return axiosVerbose
      .get(`${apiUrlPrefix}/shopfront_api/homepage/${currentSite}`)
      .then(response => {
        const action: IGetHomePageApiSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
        }
        dispatch(setSeoMeta(response.data.metadata))
        return dispatch(action)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const action: IGetHomePageApiFailAction = {
          type: TypeKeys.GET_HOME_PAGE_API_FAIL
        }
        return dispatch(action)
      })
  }
}
